import httpService from '@/core/http-service'
import authorizationService from '@/core/auth/authorization-service'

function submitCalculations(localErrand) {
  return httpService.post('rpc/errand/submitCalculations', localErrand)
}

function approvePreliminaryCalculation(localErrand) {
  return httpService.post('rpc/errand/approvePreliminaryCalculation', localErrand)
}

function approveFinalCalculation(localErrand) {
  return httpService.post('rpc/errand/approveFinalCalculation', localErrand)
}

function approveMainKeyEntrance(localErrand) {
  return httpService.post('rpc/errand/approveMainKeyEntrance', localErrand)
}

function completeOnboarding(localErrand) {
  return httpService.post('rpc/errand/completeOnboarding', localErrand)
}

function processTaskSteps(localErrand) {
  return httpService.post('rpc/errand/processTaskSteps', localErrand)
}

function searchAddress(params) {
  return httpService.get('rpc/search/address', params)
}

function resetPassword(username, cultureName) {
  return httpService.get('rpc/members/resetPassword', { username, cultureName })
}

function submitResetPassword(id, password) {
  return httpService.get('rpc/members/submitResetPassword', { id, password })
}

function setWhatsNewTimeStamp() {
  const username = authorizationService.getClaim('unique_name')
  return httpService.get('rpc/members/setWhatsNewTimeStamp', { username })
}

function getWhatsNewPopupData() {
  const username = authorizationService.getClaim('unique_name')
  return httpService.get('rpc/members/getWhatsNewPopupData', { username })
}

export default { submitCalculations, approvePreliminaryCalculation, approveFinalCalculation, approveMainKeyEntrance, completeOnboarding, processTaskSteps, searchAddress, resetPassword, submitResetPassword, setWhatsNewTimeStamp, getWhatsNewPopupData }
